import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import {
  Grid,
  Header,
  Menu,
} from 'semantic-ui-react';
import _ from 'lodash';
import { numericRange } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';

export default class IncomeForm extends Component {
  static propTypes = {
    income: PropTypes.shape({
      isSimple: PropTypes.bool,
    }),
    onChange: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    isEditing: PropTypes.bool,
  }
  static defaultValues = {
    isSimple: true,
    basicIncome: 0,
    fixAllowance: 0,
    grossIncome: 0,
    deduction: 0,
    netIncome: 0,
    currentLoanAmount: 0,
  }
  static getPropsToState = (props) => {
    const income = Object.assign({}, IncomeForm.defaultValues, props.income || {});
    return {
      income,
      oriIncome: clone(income),
    };
  }
  constructor(props) {
    super(props);
    const state = IncomeForm.getPropsToState(props);
    this.state = {
      ...state,
      errMessages: [],
    };
    this.validation = {
      currentLoanAmount: createRef(),
      netIncome: createRef(),
      basicIncome: createRef(),
      fixAllowance: createRef(),
      deduction: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = IncomeForm.getPropsToState(nextProps);
    if (JSON.stringify(state.oriIncome) === JSON.stringify(this.state.oriIncome)) {
      state.income = this.state.income;
    }
    this.setState(state);
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = () => {
    const { income } = this.state;
    if (income.isSimple) {
      income.basicIncome = 0;
      income.deduction = 0;
      income.fixAllowance = 0;
      income.grossIncome = 0;
    }
    AppForm.validate(this.validation, income)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        this.props.onSubmit(validations, income);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      const { income } = this.state;
      this.props.onChange(income);
    }
  }
  handleInputChange = (event, data) => {
    const { income } = this.state;
    income[data.name] = _.toNumber(data.value);
    if (!income.isSimple) {
      income.grossIncome = _.toNumber(income.basicIncome) + _.toNumber(income.fixAllowance);
      income.netIncome = _.toNumber(income.grossIncome) - _.toNumber(income.deduction);
    }
    this.setState({ income }, () => {
      this.handleCheckChanges();
    });
  }
  tabs = [
    { name: 'isSimple', text: 'Monthly Net Income', description: 'Basic calculation', isSimple: true },
    { name: 'isAdvance', text: 'Detailed Income', description: 'For more accurate calculation', isSimple: false },
  ];
  handleChangeTab = (isSimple = false) => {
    const { income } = this.state;
    income.isSimple = isSimple;
    this.setState({ income });
  }
  render() {
    const { income } = this.state;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns={1} textAlign="center" stackable doubling>
          <Grid.Row>
            <Grid.Column
              mobile={16}
              tablet={this.props.isEditing ? 6 : 11}
              computer={this.props.isEditing ? 5 : 9}
            >
              <AppForm.Input
                label={
                  <Header
                    as="h5"
                    style={{ marginBottom: '0.5em' }}
                    textAlign="left"
                    content="Housing Loan Amount"
                    subheader="Current Housing Loan Amount"
                  />
                }
                validateLabel="Housing Loan Amount"
                type="number"
                step="0.01"
                name="currentLoanAmount"
                value={income.currentLoanAmount}
                onChange={this.handleInputChange}
                ref={this.validation.currentLoanAmount}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column
              mobile={16}
              tablet={this.props.isEditing ? 10 : 16}
              computer={this.props.isEditing ? 10 : 16}
            >
              {
                !this.props.isEditing ?
                  <h3
                    style={{
                      color: '#FFF79A',
                      textAlign: 'left',
                      textTransform: 'uppercase',
                    }}
                  >
                    Choose one
                  </h3> :
                  null
              }
              <Menu fluid widths={2}>
                {
                  this.tabs.map((tab, idx) => (
                    <Menu.Item
                      key={idx}
                      name={tab.name}
                      onClick={() => this.handleChangeTab(tab.isSimple)}
                      active={income.isSimple === tab.isSimple}
                    >
                      <Header
                        content={tab.text}
                        subheader={tab.description}
                      />
                    </Menu.Item>
                  ))
                }
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {
              income.isSimple ? (
                <Grid.Column
                  mobile={16}
                  tablet={this.props.isEditing ? 6 : 11}
                  computer={this.props.isEditing ? 5 : 9}
                >
                  <AppForm.Input
                    label="Net Monthly Income"
                    type="number"
                    step="0.01"
                    name="netIncome"
                    value={income.netIncome}
                    validation={income.isSimple ? [{
                      validate: numericRange,
                      option: {
                        min: 1,
                        message: 'Net Monthly Income is required',
                      },
                    }] :
                    null
                    }
                    onChange={this.handleInputChange}
                    ref={this.validation.netIncome}
                  />
                </Grid.Column>
              ) : null
            }
            {
              !income.isSimple ? (
                <Grid.Column
                  mobile={16}
                  tablet={this.props.isEditing ? 6 : 11}
                  computer={this.props.isEditing ? 5 : 9}
                >
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Basic Monthly Income"
                        subheader="Monthly Basic Salary, Monthly Recurring Commission before any deduction"
                      />
                    }
                    validateLabel="Basic Monthly Income"
                    type="number"
                    step="0.01"
                    name="basicIncome"
                    value={income.basicIncome}
                    onChange={this.handleInputChange}
                    validation={!income.isSimple ? [{
                      validate: numericRange,
                      option: {
                        min: 1,
                        message: 'Basic Monthly Income is required',
                      },
                    }] : null}
                    ref={this.validation.basicIncome}
                  />
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Fix Monthly Allowance"
                        subheader="Recurring fixed travel allowance, meal allowance, yearly contractual bonus/12months"
                      />
                    }
                    validateLabel="Fix Monthly Allowance"
                    type="number"
                    step="0.01"
                    name="fixAllowance"
                    value={income.fixAllowance}
                    onChange={this.handleInputChange}
                    ref={this.validation.fixAllowance}
                  />
                  <AppForm.Input
                    label="Gross Monthly Income"
                    type="number"
                    step="0.01"
                    name="grossIncome"
                    value={income.grossIncome}
                    disabled
                    readOnly
                  />
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Monthly Income deduction"
                        subheader="EPF, SOSCO, PCB, CP38"
                      />
                    }
                    validateLabel="Monthly Income deduction"
                    type="number"
                    step="0.01"
                    name="deduction"
                    value={income.deduction}
                    onChange={this.handleInputChange}
                    ref={this.validation.deduction}
                  />
                  <AppForm.Input
                    label="Net Monthly Income"
                    type="number"
                    step="0.01"
                    name="netIncome"
                    value={income.netIncome}
                    disabled
                    readOnly
                  />
                </Grid.Column>
              ) : null
            }
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/IncomeForm.jsx